import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InstancesService {

  constructor(
    private http: HttpClient
  ) { }

  getInstance(): Observable<any> {
    return this.http.get(environment.apiUrl + '/instance/getInstance');
  }

}
